export default __webpack_public_path__ + "static/adc_symbol-c2c6e1be6b2cd7fd88425b95eca171c3.svg";